import React, { useState, useEffect } from 'react';
import {
	Paper,
  Box
} from '@mui/material';
import useMdUpScreen from '../hooks/useMdUpScreen';

function TransparentContainer({ children, mtd = '12%', mtm = '20%', wd = '90%', wm = '80%', hd = '50%', hm = '80%', heightRef = null, opacity = '0.6', refreshSize = 0 }) {
  const [height, setHeight] = useState(0);
  useEffect(() => {
    if(heightRef && heightRef.current !== null && heightRef.current.clientHeight){
      setTimeout(() => {
        if (heightRef.current !== null) setHeight(heightRef.current.clientHeight);
      }, 1)
    }
  },[heightRef,refreshSize]);
  const mdUpScreen = useMdUpScreen();
  const resvonsiveContainerHeight = mdUpScreen ? hd : hm;
  const containerHeight = height === 0 ? resvonsiveContainerHeight : height;
  const containerSx = {
    mt: mdUpScreen ? mtd : mtm,
    mx: 'auto',
    width: mdUpScreen ? wd : wm,
    height: containerHeight,
    position: 'relative',
  };
  const allSize = {
    height: '100%',
    width: '100%',
  };
  return (
    <Box sx={containerSx}>
  		<Paper sx={{ ...allSize, opacity, bgcolor: 'surfaces.main', borderRadius: '26px' }} square />
      <Box sx={{ ...allSize, position: 'absolute', top: 0, left: 0, opacity: '1' }}>
       {children}
      </Box>
   </Box>
  );
}

export default TransparentContainer;